"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_FEATURES = void 0;
exports.ACCOUNT_FEATURES = Object.freeze({
    skuCreateEdit: "sku_create_edit",
    opsDashboardNav: "ops_dashboard_nav",
    callbackManagement: "callback_management",
    newUi: "new_ui",
    printStationManagement: "print_station_management"
});
